// https://vuex.vuejs.org/en/modules.html
// eslint-disable-next-line import/no-extraneous-dependencies
import { auroraStore } from 'vuetify-aurora';

const requireModule = require.context('.', true, /\.js$/);
const modules = {};

requireModule.keys().forEach((fileName) => {
  if (fileName === './index.js') return;

  // Replace ./ and .js
  const path = fileName.replace(/(\.\/|\.js)/g, '');
  const [moduleName, imported] = path.split('/');

  if (!modules[moduleName]) {
    modules[moduleName] = {
      namespaced: true,
    };
  }

  modules[moduleName][imported] = requireModule(fileName).default;
});
auroraStore.namespaced = true;
modules.aurora = auroraStore;
export default modules;
